// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%235A6480%27 stroke-width=%272.5%27 stroke-linecap=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.f-grid {
  display: grid;
  gap: 15px;
}

.f-grid-2 {
  grid-template-columns: 1fr 1fr;
}

.f-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.f-field label {
  font-family: var(--font-display);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-soft);
}

.f-optional {
  font-weight: 500;
  color: var(--muted2);
}

.f-input,
.f-select,
.f-textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: #fff;
  font-family: var(--font-body);
  font-size: 0.95rem;
  color: var(--text);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.f-textarea {
  min-height: 118px;
  resize: vertical;
  line-height: 1.6;
}

.f-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 13px center;
  padding-right: 38px;
}

.f-input:focus,
.f-select:focus,
.f-textarea:focus {
  outline: none;
  border-color: var(--brand);
  box-shadow: 0 0 0 3px var(--brand-100);
}

.f-input::placeholder,
.f-textarea::placeholder {
  color: var(--muted2);
}

.f-input:disabled,
.f-select:disabled,
.f-textarea:disabled {
  background: var(--bg);
  color: var(--muted);
}

.f-pass {
  position: relative;
}

.f-pass .f-input {
  padding-right: 44px;
}

.f-eye {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}

.f-eye:hover {
  background: var(--brand-50);
  color: var(--brand);
}

.f-hint {
  font-size: 0.79rem;
  color: var(--muted2);
  line-height: 1.5;
}

.f-error {
  font-size: 0.79rem;
  color: var(--danger);
}

.f-input-invalid {
  border-color: var(--danger-400);
}

.f-alert {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 12px 13px;
  border-radius: var(--radius-sm);
  font-size: 0.88rem;
  line-height: 1.5;
}

.f-alert svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.f-alert-ok {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #065f46;
}

.f-alert-err {
  background: var(--danger-50);
  border: 1px solid var(--danger-100);
  color: var(--danger-700);
}

.f-alert-info {
  background: var(--brand-50);
  border: 1px solid var(--brand-100);
  color: var(--brand-800);
}

.f-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 20px;
  border: 0;
  border-radius: var(--radius);
  background: var(--brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  box-shadow: var(--shadow-brand);
  transition: background 0.2s, transform 0.15s;
}

.f-submit:hover:not(:disabled) {
  background: var(--brand-700);
  transform: translateY(-1px);
}

.f-submit:disabled {
  opacity: 0.65;
  cursor: default;
  box-shadow: none;
}

.f-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 11px 16px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: #fff;
  color: var(--brand);
  font-family: var(--font-display);
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.f-ghost:hover:not(:disabled) {
  border-color: var(--brand);
  background: var(--brand-50);
}

.f-ghost:disabled {
  opacity: 0.6;
  cursor: default;
}

.f-link {
  align-self: flex-end;
  background: none;
  border: 0;
  padding: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--brand);
  cursor: pointer;
  text-decoration: none;
}

.f-link:hover {
  text-decoration: underline;
}

.f-check {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  font-size: 0.86rem;
  line-height: 1.55;
  color: var(--muted);
}

.f-check input {
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  margin-top: 2px;
  accent-color: var(--brand);
}

.f-choices {
  display: grid;
  gap: 11px;
}

.f-choice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px 16px;
  border: 2px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}

.f-choice:hover {
  border-color: var(--brand-300);
}

.f-choice-on {
  border-color: var(--brand);
  background: var(--brand-50);
  box-shadow: var(--shadow-sm);
}

.f-choice-ico {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  background: var(--brand-100);
  color: var(--brand);
}

.f-choice-on .f-choice-ico {
  background: var(--brand);
  color: #fff;
}

.f-choice-txt strong {
  display: block;
  font-family: var(--font-display);
  font-size: 0.95rem;
  color: var(--text);
  margin-bottom: 2px;
}

.f-choice-txt span {
  font-size: 0.84rem;
  line-height: 1.5;
  color: var(--muted);
}

@media (max-width: 560px) {
  .f-grid-2 {
    grid-template-columns: 1fr;
  }
}

.od-danger:hover:not(:disabled) {
  border-color: var(--danger-100);
  background: var(--danger-50);
  color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./src/app/forms.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yDAAkP;EAClP,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;AACtB","sourcesContent":[".f-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.f-grid {\n  display: grid;\n  gap: 15px;\n}\n\n.f-grid-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n.f-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.f-field label {\n  font-family: var(--font-display);\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-soft);\n}\n\n.f-optional {\n  font-weight: 500;\n  color: var(--muted2);\n}\n\n.f-input,\n.f-select,\n.f-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: #fff;\n  font-family: var(--font-body);\n  font-size: 0.95rem;\n  color: var(--text);\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.f-textarea {\n  min-height: 118px;\n  resize: vertical;\n  line-height: 1.6;\n}\n\n.f-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%235A6480' stroke-width='2.5' stroke-linecap='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 13px center;\n  padding-right: 38px;\n}\n\n.f-input:focus,\n.f-select:focus,\n.f-textarea:focus {\n  outline: none;\n  border-color: var(--brand);\n  box-shadow: 0 0 0 3px var(--brand-100);\n}\n\n.f-input::placeholder,\n.f-textarea::placeholder {\n  color: var(--muted2);\n}\n\n.f-input:disabled,\n.f-select:disabled,\n.f-textarea:disabled {\n  background: var(--bg);\n  color: var(--muted);\n}\n\n.f-pass {\n  position: relative;\n}\n\n.f-pass .f-input {\n  padding-right: 44px;\n}\n\n.f-eye {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--muted);\n  cursor: pointer;\n}\n\n.f-eye:hover {\n  background: var(--brand-50);\n  color: var(--brand);\n}\n\n.f-hint {\n  font-size: 0.79rem;\n  color: var(--muted2);\n  line-height: 1.5;\n}\n\n.f-error {\n  font-size: 0.79rem;\n  color: var(--danger);\n}\n\n.f-input-invalid {\n  border-color: var(--danger-400);\n}\n\n.f-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  padding: 12px 13px;\n  border-radius: var(--radius-sm);\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n.f-alert svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.f-alert-ok {\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  color: #065f46;\n}\n\n.f-alert-err {\n  background: var(--danger-50);\n  border: 1px solid var(--danger-100);\n  color: var(--danger-700);\n}\n\n.f-alert-info {\n  background: var(--brand-50);\n  border: 1px solid var(--brand-100);\n  color: var(--brand-800);\n}\n\n.f-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px 20px;\n  border: 0;\n  border-radius: var(--radius);\n  background: var(--brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n  box-shadow: var(--shadow-brand);\n  transition: background 0.2s, transform 0.15s;\n}\n\n.f-submit:hover:not(:disabled) {\n  background: var(--brand-700);\n  transform: translateY(-1px);\n}\n\n.f-submit:disabled {\n  opacity: 0.65;\n  cursor: default;\n  box-shadow: none;\n}\n\n.f-ghost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 11px 16px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: #fff;\n  color: var(--brand);\n  font-family: var(--font-display);\n  font-size: 0.88rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.f-ghost:hover:not(:disabled) {\n  border-color: var(--brand);\n  background: var(--brand-50);\n}\n\n.f-ghost:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.f-link {\n  align-self: flex-end;\n  background: none;\n  border: 0;\n  padding: 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--brand);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.f-link:hover {\n  text-decoration: underline;\n}\n\n.f-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  font-size: 0.86rem;\n  line-height: 1.55;\n  color: var(--muted);\n}\n\n.f-check input {\n  flex-shrink: 0;\n  width: 17px;\n  height: 17px;\n  margin-top: 2px;\n  accent-color: var(--brand);\n}\n\n.f-choices {\n  display: grid;\n  gap: 11px;\n}\n\n.f-choice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 15px 16px;\n  border: 2px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;\n}\n\n.f-choice:hover {\n  border-color: var(--brand-300);\n}\n\n.f-choice-on {\n  border-color: var(--brand);\n  background: var(--brand-50);\n  box-shadow: var(--shadow-sm);\n}\n\n.f-choice-ico {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  background: var(--brand-100);\n  color: var(--brand);\n}\n\n.f-choice-on .f-choice-ico {\n  background: var(--brand);\n  color: #fff;\n}\n\n.f-choice-txt strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 0.95rem;\n  color: var(--text);\n  margin-bottom: 2px;\n}\n\n.f-choice-txt span {\n  font-size: 0.84rem;\n  line-height: 1.5;\n  color: var(--muted);\n}\n\n@media (max-width: 560px) {\n  .f-grid-2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.od-danger:hover:not(:disabled) {\n  border-color: var(--danger-100);\n  background: var(--danger-50);\n  color: var(--danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
